import React from 'react';

import AddChildForm from '../../components/AddChildForm';


const AddChild = () => {
    return <AddChildForm />
}

export default AddChild;